// src/pages/league-dashboard/live-draft/utils/socketHandlers.js
//
// Extracted from inline definitions in LiveDraft.js per Tier 2 #8
// commit 8a (refactor only — no behavior change).
//
// createSocketHandlers: factory returning the 6 socket event handlers
// the parent registers in its useEffect. Refs are passed through so
// handlers read the latest values when fired (matches inline closure
// behavior).
//
// buildMakePickPayload: pure helper matching the inline socket.emit
// payload shape used at the 2 make-pick call sites.
import notificationService from '../../../../services/notificationService';

export const createSocketHandlers = ({ myTeamIdRef, setTimerDataRef }) => {
  const handlePickMade = (data) => {
    const currentTeamId = myTeamIdRef.current;
    const isYourPick = currentTeamId && data.team_id === currentTeamId;
    notificationService.notifyPickMade(
      data.team_name,
      data.player?.info?.full_name || 'Unknown Player',
      isYourPick
    );
  };

  const handleYourTurn = (data) => {
    const currentTeamId = myTeamIdRef.current;
    if (data.team_id === currentTeamId) {
      notificationService.notifyYourTurn(data.pick_number);
    }
  };

  const handleTimerExpired = (data) => {
    notificationService.showBrowserNotification(
      'Timer Expired',
      data.message || 'Your time is up!',
      { tag: 'timer-expired' }
    );
  };

  const handleDraftStarted = (data) => {
    notificationService.showBrowserNotification(
      'Draft Started',
      'The draft has begun!',
      { tag: 'draft-started' }
    );
    // Initialize timer if timer data is provided in the event
    if (data?.timer && setTimerDataRef.current) {
      setTimerDataRef.current({
        started_at: data.timer.started_at,
        expires_at: data.timer.expires_at,
        duration_seconds: data.timer.duration_seconds
      });
    }
  };

  const handleDraftComplete = () => {
    notificationService.notifyDraftComplete();
  };

  const handlePicksTraded = (data) => {
    data.affected_picks?.forEach(pick => {
      notificationService.showBrowserNotification(
        'Pick Traded',
        `Pick #${pick.pick_number} traded from ${pick.old_owner_team_name} to ${pick.new_owner_team_name}`,
        { tag: 'pick-traded', silent: true }
      );
    });
  };

  return {
    handlePickMade,
    handleYourTurn,
    handleTimerExpired,
    handleDraftStarted,
    handleDraftComplete,
    handlePicksTraded,
  };
};

export const buildMakePickPayload = ({ pickId, leaguePlayerId, contractYears, slot }) => ({
  pick_id: pickId,
  league_player_id: leaguePlayerId,
  contract_years: contractYears,
  roster_status: slot.roster_status,
  roster_position: slot.roster_position,
});
